import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import { authAPI, getConfig } from "../../../apis";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import EmailInput from "../../../pages/SavedPage/EmailBlock/EmailUserBlock";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../functions/isMobile";
import { axiosInstance } from "../../../functions/axios";

const PopupUserInvite = (props) => {
  const isMobile = useIsMobile();
  const { showPopup, setShowPopup } = props;
  const [emailList, setEmailList] = useState([]);
  const [marginTop, setMarginTop] = useState(0);
  const [invitationCount, setInvitationCount] = useState(0);
  const [containerHeight, setContainerHeight] = useState("0px");
  const { user } = useSelector((state) => state.auth);
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const getUserCount = async () => {
    const { data } = await axiosInstance.get(
      `${authAPI.getUserInvitationCount}?userId=${user.userId}`,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    setInvitationCount(data);
  };

  const checkIndividualEmail = async (currentEmail) => {
    try {
      const { data } = await axiosInstance.get(
        `${authAPI.checkUserInvite}?emailId=${currentEmail}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      if (!data) {
        toast.error("That friend already has a Sooth account!");
      } else {
        setEmailList([...emailList, currentEmail]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendUserInvite = async () => {
    if (emailList.length === 0) {
      toast.error(
        "Please enter an email to share to your friend before pressing send."
      );
    } else {
      try {
        const res = await axiosInstance.post(
          authAPI.userInvite,
          {
            emails: emailList,
            invitedByUserId: user.userId,
          },
          getConfig()
        );

        if (res.data) {
          toast.success(
            "Great job! Your friend will soon receive an invitation to join Sooth!"
          );
        }
        setShowPopup(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSave = () => {
    sendUserInvite();
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  return (
    showPopup && (
      <>
        <div className="bg-dark" />
        <Draggable
          defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
          onDrag={handleDrag}
          cancel={isMobile ? ".new-user-invite-popup" : null}
        >
          <div className="new-user-invite-popup">
            <div
              className="popup-card"
              style={{
                marginTop: marginTop,
              }}
            >
              <CloseIcon
                className="cross"
                onClick={() => setShowPopup(false)}
              />

              <p className="popup-title">
                Help spread the power: invite a new user today!
              </p>
              <EmailInput
                setMarginTop={setMarginTop}
                emailList={emailList}
                containerHeight={containerHeight}
                setContainerHeight={setContainerHeight}
                setEmailList={setEmailList}
                getUserCount={getUserCount}
                invitationCount={invitationCount}
                checkIndividualEmail={checkIndividualEmail}
              />
              <div className="save-actions">
                <div />
                <div className="flex mt-2">
                  <ButtonPrimary
                    text="Cancel"
                    onClick={() => setShowPopup(false)}
                    className="mr-2 grey"
                    outline
                  />
                  <ButtonPrimary text="Send" onClick={handleSave} />
                </div>
              </div>
            </div>
          </div>
        </Draggable>
      </>
    )
  );
};

export default PopupUserInvite;
